import React, { useState } from 'react'
import { TextField } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { DesktopDatePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

const InvoiceDateRangePicker = () => {
  const [startDate, setStartDate] = useState<Date | null>()
  const [endDate, setEndDate] = useState<Date | null>()

  const handleStartDate = (newValue: Date | null) => {
    setStartDate(newValue)
  }

  const handleEndDate = (newValue: Date | null) => {
    setEndDate(newValue)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        label='Start Date'
        inputFormat='dd/MM/yyyy'
        value={startDate}
        onChange={handleStartDate}
        renderInput={(params) => (
          <TextField placeholder='Start Date' {...params} />
        )}
      />
      <DesktopDatePicker
        label='End Date'
        inputFormat='dd/MM/yyyy'
        value={endDate}
        onChange={handleEndDate}
        renderInput={(params) => (
          <TextField placeholder='End Date' {...params} />
        )}
      />
    </LocalizationProvider>
  )
}

export default InvoiceDateRangePicker
